function toggleCart(product, quantity) {
  return {
    type: "MODIFY_CART_CONTENT",
    payload: [
      {
        id: product.id,
        name: product.name,
        sellingPrice: product.price,
        quantity,
      },
    ],
  };
}

export default toggleCart;
